<template>
  <div :class="b()" :style="styleSizeName">
    <div :class="b('opration')" :style="oprationStyle">
      <div :class="b('opration--scale')" :style="oprationTextStyle">
        <i class="iconfont icon-jian scaleBtn" @click="myChart.scale -= 0.1"></i>
        <span class="sizeText" @click="myChart.scale = 1">{{ scaleText }}</span>
        <i class="iconfont icon-jia scaleBtn" @click="myChart.scale += 0.1"></i>
      </div>
      <a :class="b('opration--fullscreen')" :style="oprationTextStyle" v-if="fullscreen">
        <i class="iconfont icon-quitquanping fullBtn"></i>
        <span class="sizeText">退出全屏</span>
      </a>
      <a :class="b('opration--fullscreen')" :style="oprationTextStyle" v-else>
        <i class="iconfont icon-quanping fullBtn"></i>
        <span class="sizeText">全屏</span>
      </a>
    </div>
    <div :class="b('content')">
      <div ref="preview" :class="b('content--preview')" :style="previewStyle"></div>
      <div ref="chart" :class="b('content--chart')"></div>
    </div>
  </div>
</template>

<script>
// import { parseUrl } from '@/utils/utils';
import init from '@/mixins/chart';
export default {
  name: 'diagram',
  inject: ['container'],
  mixins: [init],
  data() {
    return {
      GO: go.GraphObject.make,
      fullscreen: false,
      scale: 1,
      myChart: null,
      preview: null,
      baseUrl: 'https://zhengxin.raysdata.com/dash/api',
      origin: 'https://zhengxin.raysdata.com/zhkDash'
    };
  },
  props: {
    option: Object,
    component: Object
  },
  computed: {
    scalePlacement() {
      return this.option.scalePlacement;
    },
    previewPlacement() {
      return this.option.previewPlacement;
    },
    oprationStyle() {
      if (this.scalePlacement == 'lt') {
        return {
          left: this.setPx(this.option.scaleSplitX),
          top: this.setPx(this.option.scaleSplitY)
        };
      } else if (this.scalePlacement == 'rt') {
        return {
          right: this.setPx(this.option.scaleSplitX),
          top: this.setPx(this.option.scaleSplitY)
        };
      } else if (this.scalePlacement == 'lb') {
        return {
          left: this.setPx(this.option.scaleSplitX),
          bottom: this.setPx(this.option.scaleSplitY)
        };
      } else {
        return {
          right: this.setPx(this.option.scaleSplitX),
          bottom: this.setPx(this.option.scaleSplitY)
        };
      }
    },
    oprationTextStyle() {
      return {
        fontSize: this.setPx(this.option.scaleSize),
        color: this.option.scaleColor
      };
    },
    previewStyle() {
      return Object.assign(
        {
          width: this.setPx(this.option.previewSize),
          height: this.setPx(this.option.previewSize),
          background: this.option.previewBgColor,
          border: `${this.option.previewBdSize}px solid ${this.option.previewBdColor}`
        },
        (() => {
          if (this.previewPlacement == 'lt') {
            return {
              left: this.setPx(this.option.previewSplitX),
              top: this.setPx(this.option.previewSplitY)
            };
          } else if (this.previewPlacement == 'rt') {
            return {
              right: this.setPx(this.option.previewSplitX),
              top: this.setPx(this.option.previewSplitY)
            };
          } else if (this.previewPlacement == 'lb') {
            return {
              left: this.setPx(this.option.previewSplitX),
              bottom: this.setPx(this.option.previewSplitY)
            };
          } else {
            return {
              right: this.setPx(this.option.previewSplitX),
              bottom: this.setPx(this.option.previewSplitY)
            };
          }
        })()
      );
    },
    scaleText() {
      return (+this.scale * 100).toFixed(0) + '%';
    }
  },
  methods: {
    // 初始化实例
    init() {
      if (this.myChart) this.myChart.div = null;
      if (this.preview) this.preview.div = null;
      this.myChart = this.GO(go.Diagram, this.$refs.chart, {
        initialContentAlignment: go.Spot.Center,
        initialDocumentSpot: go.Spot.Center,
        initialViewportSpot: go.Spot.Center,
        scrollMode: go.Diagram.InfiniteScroll,
        'toolManager.mouseWheelBehavior': go.ToolManager.WheelZoom, //获取或设置鼠标滚轮行为。
        initialScale: this.scale,
        scale: this.scale,
        allowSelect: false
      });
      this.myChart.addDiagramListener('ViewportBoundsChanged', e => (this.scale = e.diagram.scale));

      this.myChart.addDiagramListener('BackgroundSingleClicked', function(e) {
        console.log('我是空白', e);
      });
      this.myChart.addDiagramListener('ObjectSingleClicked', function(e) {
        console.log('我是单机', e);
        //Select_Port = e.subject.part.data.key;    e.subject.part.data即获取到的data
      });
      go.GraphObject.defineBuilder('SubGraphExpanderButton1', () => {
        var button = /** @type {Panel} */ (go.GraphObject.make(
          'Button',
          {
            _subGraphExpandedFigure: 'PlusLine',
            _subGraphCollapsedFigure: 'MinusLine',
            'ButtonBorder.figure': 'Ellipse',
            'ButtonBorder.fill': 'transparent',
            'ButtonBorder.stroke': this.option.edgeColor,
            _buttonFillOver: 'transparent',
            _buttonStrokeOver: this.option.edgeColor,
            _buttonFillPressed: 'transparent',
            _buttonStrokePressed: this.option.edgeColor
          },
          go.GraphObject.make(
            go.Shape, // the icon
            {
              name: 'ButtonIcon',
              figure: 'PlusLine',
              stroke: this.option.edgeColor,
              strokeWidth: 2,
              desiredSize: new go.Size(8, 8)
            },
            new go.Binding('figure', 'isSubGraphExpanded', function(exp, shape) {
              var but = shape.panel;
              return exp ? but['_subGraphExpandedFigure'] : but['_subGraphCollapsedFigure'];
            }).ofObject()
          )
        ));
        //subgraph expand/collapse behavior
        button.click = (e, btn) => {
          var group = btn.part;
          var params = {
            name: btn.part.data.data.company,
            key: btn.part.data.key,
            position: btn.part.data.dir
          };

          window.axios
            .post(this.option.nextUrl, params)
            .then(data => {
              var node = data.nodes;
              e.diagram.startTransaction('Create new detached node');
              e.diagram.model.setDataProperty(btn.part.data, 'isAdd', false);
              for (var i = 0; i < node.length; i++) {
                e.diagram.model.addNodeData(node[i]);
              }
              this.initLayout();
              e.diagram.commitTransaction('Create new detached node');
              if (group instanceof go.Adornment) group = group.adornedPart;
              if (!(group instanceof go.Group)) return;
              var diagram = group.diagram;
              if (diagram === null) return;
              var cmd = diagram.commandHandler;
              if (group.isSubGraphExpanded) {
                if (!cmd.canCollapseSubGraph(group)) return;
              } else {
                if (!cmd.canExpandSubGraph(group)) return;
              }
              e.handled = true;
              if (group.isSubGraphExpanded) {
                cmd.collapseSubGraph(group);
              } else {
                cmd.expandSubGraph(group);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        };
        return button;
      });
    },
    // 渲染关系图
    updateChart() {
      this.initNodes();
      this.initLinks();
      const optionData = this.deepClone(this.dataChart);
      this.myChart.model = new go.TreeModel(optionData);
      this.initLayout();
      this.preview = this.GO(go.Overview, this.$refs.preview, {
        observed: this.myChart
      });
      this.preview.box.elt(0).stroke = '#fff';
    },
    // 初始化布局
    initLayout() {
      this.myChart.startTransaction('Double Tree Layout');
      var leftParts = new go.Set(go.Part);
      var rightParts = new go.Set(go.Part);
      var root = this.myChart.findNodeForKey('root');
      if (root) {
        leftParts.add(root);
        rightParts.add(root);
        root.findTreeChildrenNodes().each(function(child) {
          var dir = child.data.dir;
          var coll = dir === 'top' ? leftParts : rightParts;
          coll.addAll(child.findTreeParts());
          coll.add(child.findTreeParentLink());
        });
      }
      var layout1 = this.GO(go.TreeLayout, {
        angle: 270,
        layerSpacing: 120,
        arrangement: go.TreeLayout.ArrangementFixedRoots
        // setsPortSpot: false
      });
      var layout2 = this.GO(go.TreeLayout, {
        angle: 90,
        layerSpacing: 120,
        arrangement: go.TreeLayout.ArrangementFixedRoots
        // setsPortSpot: false
      });
      layout1.doLayout(leftParts);
      layout2.doLayout(rightParts);
      this.myChart.commitTransaction('Double Tree Layout');
    },
    // 初始化节点
    initNodes() {
      const _that = this;
      this.myChart.nodeTemplate = this.GO(
        go.Node,
        'Auto',
        {
          selectable: false
        },
        this.GO(
          go.Panel,
          'Vertical',
          this.GO(
            'SubGraphExpanderButton1',
            {
              alignment: go.Spot.Center,
              visible: false
            },
            new go.Binding('visible', '', data => data.dir == 'top' && data.isAdd)
          ),
          //最终受益人
          this.GO(
            go.Panel,
            'Auto',
            new go.Binding('visible', 'data', data => !!data.beneficiary),
            this.GO(go.Shape, 'Rectangle', {
              alignment: go.Spot.TopRight,
              fill: '#39B2F9',
              stroke: '#D8D8D8',
              width: 140,
              height: 30
            }),
            this.GO(
              go.Panel,
              'Auto',
              this.GO(go.TextBlock, {
                stroke: '#fff',
                text: '最终受益人'
              })
            )
          ),
          this.GO(
            go.Panel,
            'Auto',
            {
              click: (e, obj) => {
                if (obj.part.data.data.code) {
                  console.log('------', obj.part.data.data);
                  _that.progressClick(obj.part.data.data);
                  // let { linkHref = '#', linkTarget } = this.option;
                  // linkHref = parseUrl(linkHref, obj.part.data.data);
                  // linkTarget === '_blank'
                  //   ? window.open(linkHref)
                  //   : (window.location.href = linkHref);
                }
              }
            },

            new go.Binding('cursor', '', data => (data.data.code ? 'pointer' : null)),
            this.GO(
              go.Shape,
              'Rectangle',
              {
                strokeWidth: 1,
                stroke: 'transparent'
              },
              new go.Binding('fill', '', data => {
                if (data.key == 'root') {
                  return this.option.rootFill || '#FF9F15';
                } else if (data.dir == 'top') {
                  return this.option.topFill || '#20B27B';
                } else if (data.dir == 'bottom') {
                  return this.option.bottomFill || '#9688E2';
                }
              }),
              new go.Binding('minSize', 'key', key =>
                key == 'root'
                  ? new go.Size(this.option.rootSize || 300, 40)
                  : new go.Size(this.option.childSize || 140, 76)
              )
            ),
            this.GO(
              go.Panel,
              'Vertical',
              this.GO(
                go.TextBlock,
                {
                  name: 'companyName',
                  margin: 5,
                  font: '14px Helvetica, sans-serif',
                  overflow: go.TextBlock.OverflowEllipsis,
                  maxLines: 2,
                  width: 120,
                  spacingAbove: 3,
                  textAlign: 'center',
                  stroke: '#fff',
                  toolTip: this.GO(
                    'ToolTip',
                    this.GO(
                      go.TextBlock,
                      {
                        margin: 4
                      },
                      new go.Binding('text', 'data', data => data.company || '')
                    )
                  )
                },
                new go.Binding('text', 'data', data => data.company || ''),
                new go.Binding('width', 'key', key =>
                  key == 'root' ? this.option.rootSize || 300 : this.option.childSize || 140
                ),
                new go.Binding('textAlign', 'key', key => (key == 'root' ? 'center' : 'left'))
              ),
              this.GO(
                go.TextBlock,
                {
                  margin: 5,
                  font: '14px Helvetica, sans-serif',
                  overflow: go.TextBlock.OverflowEllipsis,
                  maxLines: 1,
                  width: this.option.childSize,
                  stroke: '#fff'
                },
                new go.Binding('text', 'data', function(data) {
                  if (data.money) {
                    let money;
                    if (data.money.indexOf('万元') !== -1) {
                      money = data.money;
                    } else {
                      money = data.money + '万元';
                    }
                    return '认缴金额：' + money;
                  } else {
                    return '';
                  }
                }),
                new go.Binding('visible', 'key', key => key !== 'root')
              )
            )
          ),
          this.GO(
            'SubGraphExpanderButton1',
            {
              alignment: go.Spot.Center,
              visible: false
            },
            new go.Binding('visible', '', data => data.dir == 'bottom' && data.isAdd)
          ),
          this.GO('TreeExpanderButton', {
            'ButtonBorder.figure': 'Ellipse',
            'ButtonBorder.fill': 'transparent',
            'ButtonBorder.stroke': this.option.edgeColor,
            'ButtonIcon.stroke': this.option.edgeColor,
            _buttonFillOver: 'transparent',
            _buttonStrokeOver: this.option.edgeColor,
            _buttonFillPressed: 'transparent',
            _buttonStrokePressed: this.option.edgeColor,
            cursor: 'pointer'
          })
        )
      );
    },
    // 初始化连接
    initLinks() {
      this.myChart.linkTemplate = this.GO(
        go.Link,
        {
          selectable: false
        },
        {
          curve: go.Link.Bezier,
          corner: 30,
          toEndSegmentLength: 70,
          fromEndSegmentLength: 70
        },
        this.GO(go.Shape, {
          stroke: this.option.edgeColor
        }),
        this.GO(
          go.Shape,
          {
            toArrow: 'Standard',
            fill: this.option.edgeColor,
            stroke: 'transparent',
            scale: 1.5
          },
          new go.Binding('toArrow', 'dir', h => (h == 'top' ? 'Backward' : 'Standard'))
        ),
        this.GO(
          go.TextBlock,
          '',
          {
            segmentIndex: 2,
            segmentFraction: 0.8,
            stroke: this.option.edgeColor
          },
          new go.Binding('text', 'data', data => data.ratio || ''),
          new go.Binding('segmentOffset', 'dir', h =>
            h == 'top' ? new go.Point(0, 30) : new go.Point(0, -30)
          )
        )
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.avue-echart-diagram {
  position: relative;

  &__opration {
    position: absolute;
    z-index: 4;
    display: flex;
    align-items: center;

    .scaleBtn,
    .fullBtn {
      font-size: 1em;
      vertical-align: middle;
      cursor: pointer;
    }

    .sizeText {
      padding: 0 10px;
      vertical-align: middle;
      cursor: pointer;
    }

    &--fullscreen {
      margin-left: 20px;
    }
  }

  &__content {
    position: relative;
    height: 100%;

    &--preview {
      position: absolute;
      z-index: 3;
      cursor: pointer;
    }

    &--chart {
      height: 100%;
    }
  }
}
</style>
